import { render, staticRenderFns } from "./RegisterPage.vue?vue&type=template&id=58c20916&scoped=true"
import script from "./RegisterPage.vue?vue&type=script&lang=js"
export * from "./RegisterPage.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/registerpage.css?vue&type=style&index=0&id=58c20916&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c20916",
  null
  
)

export default component.exports